import React, { useContext } from 'react';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import SpeicherfuchsDashboard from '../apps/speicherfuchs/Dashboard';
import CRMDashboard from '../apps/crm/Dashboard';
import MarketingDashboard from '../apps/marketing/Dashboard';
import SavySpeakDashboard from '../apps/savvyspeak/Dashboard';
import SettingsDashboard from 'apps/settings/Dashboard';
import { APP_KEYS } from 'constants';

function Dashboard() {
    console.log('before call')
    const { userSettings } = useContext(UserSettingsContext);

    console.log(userSettings)

    switch(userSettings.selected_app) {
        case APP_KEYS.SPEICHERFUCHS: return <SpeicherfuchsDashboard />;
        case APP_KEYS.CRM: return <CRMDashboard />;
        case APP_KEYS.MARKETING: return <MarketingDashboard />;
        case APP_KEYS.SETTINGS: return <SettingsDashboard />;
        case APP_KEYS.SAVVYSPEAK: return <SavySpeakDashboard />;
        default: return <CRMDashboard />;
    }
}

export default Dashboard;



